var n = Object.defineProperty;
var b = (m, o, i) => o in m ? n(m, o, { enumerable: !0, configurable: !0, writable: !0, value: i }) : m[o] = i;
var r = (m, o, i) => (b(m, typeof o != "symbol" ? o + "" : o, i), i);
import "fabric";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import { calcCalloutScale as d } from "./index.es252.js";
import "./index.es4.js";
import "./index.es20.js";
import "react";
import { usePLMapboxLayersStore as l } from "./index.es12.js";
import "@tanstack/react-query";
import "qs";
import "./index.es46.js";
import "./index.es6.js";
import "./index.es99.js";
import "react/jsx-runtime";
import "@placer-ui/components";
import "./index.es203.js";
import "./index.es204.js";
import "./index.es205.js";
import "./index.es206.js";
import "use-debounce";
import "@deck.gl/geo-layers/typed";
import "@deck.gl/core/typed";
import "@deck.gl/layers/typed";
import "react-map-gl";
import { isLayerIdSelected as _ } from "./index.es399.js";
import "geobuckets";
import "./index.es207.js";
import "./index.es59.js";
import "./index.es74.js";
import "./index.es82.js";
import "./index.es113.js";
import "@deck.gl/extensions/typed";
import "kdbush";
import "./index.es208.js";
import "./index.es230.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "./index.es234.js";
import "./index.es131.js";
import "./index.es166.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es235.js";
import "@sentry/react";
import "./index.es43.js";
import "lodash";
import "./index.es84.js";
import "./index.es23.js";
import "./index.es18.js";
import "./index.es72.js";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es90.js";
import "lodash/fp";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es78.js";
import "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import "./index.es86.js";
import "./index.es209.js";
import "./index.es103.js";
import "react-dom";
import "classnames";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "./index.es214.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es170.js";
import { Textbox as u } from "./index.es173.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es227.js";
import "./index.es228.js";
import "./index.es229.js";
import "./index.es236.js";
import "./index.es137.js";
import "./index.es138.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import "./index.es35.js";
import "mapbox-gl";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
import { getOffsetFromStore as S } from "./index.es448.js";
class Io {
  constructor(o) {
    r(this, "_layerDataMap");
    r(this, "_map");
    r(this, "_mapId");
    r(this, "_subLayerId");
    r(this, "_layerGroupId");
    r(this, "_combinedLayerId");
    r(this, "_labelInfo");
    r(this, "_styleType");
    r(this, "_drawType", "Textbox");
    r(this, "_visible");
    r(this, "_offset");
    r(this, "_isSelected");
    r(this, "_geolocation");
    r(this, "data");
    r(this, "_generateTextbox", async () => {
      const o = this._map, i = this._geolocation, t = o.project(i), e = o.getZoom(), p = d(e, this._drawType), y = {
        x: 0,
        y: 50
      }, a = S({
        mapId: this._mapId,
        layerGroupId: this._layerGroupId,
        subLayerId: this._subLayerId,
        state: l.getState(),
        poiId: this.data.poiId
      }), x = _(
        this._mapId,
        l.getState(),
        this._combinedLayerId
      ), s = new u({
        layerGroupId: this._layerGroupId,
        combinedLayerId: this._combinedLayerId,
        styleType: this._styleType,
        subLayerId: this._subLayerId,
        map: this._map,
        projectedXYSource: t,
        offsetXYFromSource: a ? { ...a } : y,
        fabricObjScale: p,
        visible: this._visible,
        textboxConfig: this.data,
        status: x ? "select" : "idle"
      });
      return await s.generate(), s;
    });
    r(this, "generate", async () => {
      const { poiId: o } = this.data, i = this._layerDataMap.get(o), t = i == null ? void 0 : i.textboxConfig, e = this.data;
      if (i && (t == null ? void 0 : t.text) === e.text && (t == null ? void 0 : t.textboxStyleConfig.backgroundContainerColor) === e.textboxStyleConfig.backgroundContainerColor && (t == null ? void 0 : t.textboxStyleConfig.backgroundContainerOpacity) === e.textboxStyleConfig.backgroundContainerOpacity && (t == null ? void 0 : t.textboxStyleConfig.backgroundCornerRadius) === e.textboxStyleConfig.backgroundCornerRadius && (t == null ? void 0 : t.textboxStyleConfig.textFontColor) === e.textboxStyleConfig.textFontColor && (t == null ? void 0 : t.textboxStyleConfig.textFontFamily) === e.textboxStyleConfig.textFontFamily && (t == null ? void 0 : t.textboxStyleConfig.textFontOpacity) === e.textboxStyleConfig.textFontOpacity && (t == null ? void 0 : t.textboxStyleConfig.textFontSize) === e.textboxStyleConfig.textFontSize && (t == null ? void 0 : t.textboxStyleConfig.textFontWeight) === e.textboxStyleConfig.textFontWeight)
        return {
          calloutBox: i,
          fromCache: !0
        };
      const p = await this._generateTextbox();
      return this._layerDataMap.set(o, p), {
        calloutBox: p,
        fromCache: !1
      };
    });
    this._map = o.map, this._mapId = o.mapId, this._layerDataMap = o.layerDataMap, this._subLayerId = o.subLayerId, this._layerGroupId = o.layerGroupId, this._combinedLayerId = o.combinedLayerId, this._labelInfo = o.data, this._styleType = o.styleType, this._visible = o.data.visible, this._offset = o.data.offset, this._isSelected = o.data.isSelected, this._geolocation = o.data.geolocation, this.data = o.data;
  }
}
export {
  Io as TextFactory
};
//# sourceMappingURL=index.es450.js.map
